<lib-header [site]="'netvote'"></lib-header>
<router-outlet></router-outlet>
<app-footer></app-footer>
